import dynamic from 'next/dynamic';
import { ErrorBoundary } from '@frameio/shared/components';
import { AlertInline, Box, SheetHead } from '@frameio/vapor';
import TEXT from './generated/TEXT/DevToolsSheet';

const DevToolsSheetContent = dynamic(
  () =>
    import('@frameio/components/DevTools/DevToolsSheet').then(
      (mod) => mod.DevToolsSheet
    ),
  {
    ssr: false,
  }
);

TEXT.DEFINE({
  /** Sheet title shown at the top of the Dev Tools panel */
  title: 'Dev Tools',
  /** Error message shown when the Dev Tools sheet fails to load */
  errorTitle: 'Something went wrong',
});

export const DevToolsSheet = () => {
  return (
    <ErrorBoundary
      fallback={
        <Box
          alignItems="center"
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
          width="100%"
        >
          <AlertInline variant="error">{TEXT.errorTitle}</AlertInline>
        </Box>
      }
    >
      <SheetHead title={TEXT.title} />
      <DevToolsSheetContent isQuickLinksSectionEnabled={true} />
    </ErrorBoundary>
  );
};
